<ppl-app-container [showCopyright]="false">
  <div class="align-in-center">
    <ppl-email-verification-verification-complete *ngIf="isEmailVerified$ | async; else verificationNeeded"
                                                  (login)="onLogin()"></ppl-email-verification-verification-complete>

    <ng-template #verificationNeeded>
      <ppl-email-verification-verification-needed [email]="email$ | async"
                                                  [error]="emailVerificationError$ | async"
                                                  [loading]="resendingVerificationEmail$ | async"
                                                  (resendEmail)="onResendEmail()"></ppl-email-verification-verification-needed>
    </ng-template>
  </div>
</ppl-app-container>
